import "regenerator-runtime";
import debug from "debug";
import ally from 'ally';

import "./components";
import "./vendor";

import * as tabmenu from '../core/components/tabmenu';
import * as menu from '../core/components/menu';
import * as lottieAnimation from '../core/components/lottieAnimation';
import * as firebase from '../core/components/firebase';

const log = debug('fusion-core');

var focusSource = ally.style.focusSource();

globalThis.resetFocus = function() {
    console.log("resetting focus to document");
    document.activeElement.blur();
};

globalThis.SetFocusToElement = function (elementId) {
    var element = document.getElementById(elementId);
    if (element != null) {
        element.focus();
    }
};

globalThis.SetLoadingAnimation = function (elementId) {
    var loadingAnimationContainer = document.getElementById('loadingAnimationContainer');
    if(loadingAnimationContainer){
        var loadingAnimation = loadingAnimationContainer.children[0];
        if(loadingAnimation){
            lottie.applyToElement(loadingAnimation);
        }
    }
};

globalThis.ScrollToId = function (id) {
    const element = document.getElementById(id);
        if (element instanceof HTMLElement) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest"
            });
            element.focus();
        }
};

globalThis.ScrollToIdIfNeeded = function (id) {
    const element = document.getElementById(id);
        if (element instanceof HTMLElement) {
            if(element.scrollIntoViewIfNeeded){
                element.scrollIntoViewIfNeeded(false);
                element.focus();
            }
        }
};

globalThis.ScrollToTop = function (id) {    
    globalThis.scrollTo({top: 0, behavior: 'smooth'});
};

globalThis.getAddClaimImageHeight = function () {

    // access DOM here
    var div = document.getElementById("add-claim-img-c");
    return div.offsetWidth / 2 + "px";
};

globalThis.moveCursorToEnd = function (id) {
    var input = document.getElementById(id);
    input.focus();
    var s = input.value;
    if (s.length) {
        globalThis.setTimeout(function () {
            input.setSelectionRange(s.length, s.length);
        }, 0);
    }
};

globalThis.openDatePicker = function (datePickerId) {
    var dateInput = document.getElementById(datePickerId);
    dateInput.show();
};

globalThis.goBack = function () {
    globalThis.history.back();
};

globalThis.goBackMany = function (delta) {
    globalThis.history.go(delta);
};

globalThis.loadIframe = function (bytesBase64) {
    var iframe = document.createElement('iframe');
    iframe.style.width = "100%";
    iframe.style.height = "780px";
    iframe.src = "data:application/pdf;base64," + bytesBase64;
    document.getElementById("content").appendChild(iframe);
    document.getElementById("display-pdf").remove();
};

globalThis.saveAsFile = function (filename, bytesBase64) {
    var link = document.createElement('a');
    link.download = filename;
    link.href = "data:application/octet-stream;base64," + bytesBase64;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

globalThis.saveBinaryAsFile = function (filename, byteArray) {
    var blob = new Blob([byteArray], { type: 'application/octet-stream' });
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.download = filename;
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

globalThis.initialiseDatePicker = function (dotNetHelper, datePickerId) {
    console.log(dotNetHelper, datePickerId);
    globalThis.customElements.whenDefined("duet-date-picker").then(() => {
        var datePicker = document.getElementById(datePickerId);
        if (datePicker) {
            datePicker.addEventListener("duetChange", function (event) {
                console.log(event.detail);
                dotNetHelper.invokeMethodAsync('UpdateDateValue', datePicker.value);
            });
        }
    });
};

globalThis.getRadioValue = function (radioName) {
    var selectedRadio = document.querySelector('input[name="' + radioName + '"]:checked');
    if(selectedRadio != null){
        return selectedRadio.value;
    }
    else{
        return null;
    }
};

globalThis.setRadioChecked = function (id) {
    var selectedRadio = document.querySelector('input[id="' + id + '"]');
    if(selectedRadio != null){
        selectedRadio.checked = true;
    }
    
};

globalThis.setRadioButtonItemWidths = function () {
    let maxWidth = 110;
    var radioItems = document.querySelectorAll('.radio-field-label');
    var radioContainer = document.querySelector('.radio-question__answers');
    // find max width based on content
    radioItems.forEach((item) => {
        const width = item.offsetWidth;
        if (width > maxWidth) {
            maxWidth = width;
        }
    });

    // apply max width to all items
    radioItems.forEach((item) => {
        item.style.width = `${maxWidth}px`;
    });

    radioContainer.style.gridTemplateColumns = `repeat(auto-fill, ${maxWidth}px)`;
};

globalThis.logEvent = function(name, params) {
    firebase.doLogEvent(name, params);
};

globalThis.CustomClickListener = {};
globalThis.addClickListener = function (dotNetHelper, scopeSelector, elementsSelector, methodIdentifier) {
    var scopeEl = document.querySelector(scopeSelector);
    if(!scopeEl) {
        return;
    }

    var listenerKey = `${scopeSelector}_${methodIdentifier}`;
    var elements = scopeEl.querySelectorAll(elementsSelector);

    // we don't want to double up on event handling, so remove any existing custom click handler
    if(typeof globalThis.CustomClickListener[listenerKey] === 'function') {
        elements.forEach( el => {
            el.removeEventListener('click', globalThis.CustomClickListener[listenerKey]);
            globalThis.CustomClickListener[listenerKey] = undefined;
        });
    }

    globalThis.CustomClickListener[listenerKey] = function(e) {
        e.preventDefault();
        e.stopPropagation();
        dotNetHelper.invokeMethodAsync(methodIdentifier);
    };

    elements.forEach( el => {
        el.addEventListener('click', globalThis.CustomClickListener[listenerKey]);
    });
};

globalThis.ScrollRight = function (Element, dotNetHelper) {
    if (document.getElementById(Element)) {
        var scrollView = document.getElementById(Element);

        if (document.getElementById('cover-card-id')) {

            var screenWidth = scrollView.offsetWidth;

            var scrollViewWidth = scrollView.scrollWidth;
            var scrollLeftWidth = scrollView.scrollLeft;
            var remainingWidth = scrollViewWidth - screenWidth - scrollLeftWidth;
            var contentWidth = document.getElementById('cover-card-id').scrollWidth;

            if(remainingWidth > contentWidth){
                scrollView.scrollBy({
                top: 0, left: contentWidth + 10, behavior: "smooth"
                });
            }else{
                var widthToScroll = contentWidth - remainingWidth;
                scrollView.scrollBy({
                top: 0, left: remainingWidth, behavior: "smooth"
                });
                dotNetHelper.invokeMethodAsync('IsScrollViewReachRightEnd', true);

            }            
        }
    }    
};

globalThis.ScrollLeft = function (Element, dotNetHelper) {
    if (document.getElementById(Element)) {
        if (document.getElementById('cover-card-id')) {
            var scrollView = document.getElementById(Element);
            var contentWidth = document.getElementById('cover-card-id').offsetWidth;
            var scrollLeftWidth = scrollView.scrollLeft;
            if(scrollLeftWidth > contentWidth){
                document.getElementById(Element).scrollBy({
                top: 0, left: -document.getElementById('cover-card-id').offsetWidth - 10, behavior: "smooth"
            });
            }else{
                document.getElementById(Element).scrollBy({
                top: 0, left: -scrollLeftWidth, behavior: "smooth"
            });
            dotNetHelper.invokeMethodAsync('IsScrollViewReachLeftEnd', true);

            }

            
        }
    }
};

globalThis.HorizontalScrollJSHelper = function (dotNetHelper) {

    if (document.getElementById("horizontal_container_scroll")) {
        var el = document.getElementById("horizontal_container_scroll");
        if (Math.abs(el.scrollLeft) === el.scrollWidth - el.clientWidth) {
            dotNetHelper.invokeMethodAsync('IsScrollViewReachRightEnd', true);
        } else {
            dotNetHelper.invokeMethodAsync('IsScrollViewReachRightEnd', false);
        }

        if (el.scrollLeft <= 0) {
            dotNetHelper.invokeMethodAsync('IsScrollViewReachLeftEnd', true);
        } else {
            dotNetHelper.invokeMethodAsync('IsScrollViewReachLeftEnd', false);

        }
    }
};

globalThis.GetHeightByElementId = function (Element, Width) {
    if (document.getElementById(Element)) {
        return document.getElementById(Element).offsetHeight;
    }
};

globalThis.setModalPopUpPageAndIntercept = (containerId, html) => {
    const container = document.getElementById(containerId);
    container.innerHTML = html;

    container.querySelectorAll("a[href]").forEach(a => {
        a.addEventListener("click", function (e) {
            e.preventDefault(); // stop default navigation
            const href = a.getAttribute("href");

            DotNet.invokeMethodAsync("MobileHealthFund.Web", "ModalPopUpPageAndInterceptHandleLinkClickById", href);
        });
    });
};

globalThis.tabmenu = tabmenu;
globalThis.lottie = lottieAnimation;
globalThis.menu = menu;

function base64UrlEncode(uint8array) {
    let str = "";
    for (const byte of uint8array) {
        str += String.fromCodePoint(byte);
    }
    const b64 = globalThis.btoa(str)
        .replaceAll("+", "-")
        .replaceAll("/", "_");

    const paddingIndex = b64.indexOf("=");
    return paddingIndex === -1 ? b64 : b64.substring(0, paddingIndex);
}

globalThis.encryptData = async (payload, jwk) => {
    try {
        // 1. Prepare Key Import
        // Ensure JWK properties are set correctly for Web Crypto
        const importJwk = {
            kty: jwk.kty,
            e: jwk.e,
            n: jwk.n,
            alg: "RSA-OAEP-256",
            ext: true,
            key_ops: ["encrypt"]
        };

        const importedKey = await globalThis.crypto.subtle.importKey(
            "jwk",
            importJwk,
            {
                name: "RSA-OAEP",
                hash: "SHA-256"
            },
            false,
            ["encrypt"]
        );

        // 2. Generate CEK (AES-GCM 256)
        const cek = await globalThis.crypto.subtle.generateKey(
            {
                name: "AES-GCM",
                length: 256
            },
            true, // extractable
            ["encrypt"]
        );

        // 3. Encrypt CEK with RSA Public Key
        const rawCek = await globalThis.crypto.subtle.exportKey("raw", cek);
        const encryptedKey = await globalThis.crypto.subtle.encrypt(
            {
                name: "RSA-OAEP"
            },
            importedKey,
            rawCek
        );

        // 4. Encrypt Payload with CEK (AES-GCM)
        const iv = globalThis.crypto.getRandomValues(new Uint8Array(12));
        
        // Prepare Header
        const header = {
            alg: "RSA-OAEP-256",
            enc: "A256GCM",
            kid: jwk.kid
        };
        const headerJson = JSON.stringify(header);
        const headerB64 = base64UrlEncode(new TextEncoder().encode(headerJson));

        // AAD is the ASCII(BASE64URL(UTF8(JWE Header)))
        const additionalData = new TextEncoder().encode(headerB64);

        const payloadBytes = new TextEncoder().encode(payload);
        
        const encryptedContent = await globalThis.crypto.subtle.encrypt(
            {
                name: "AES-GCM",
                iv: iv,
                additionalData: additionalData,
                tagLength: 128
            },
            cek,
            payloadBytes
        );

        const encryptedContentBytes = new Uint8Array(encryptedContent);
        const tagLength = 16;
        const ciphertext = encryptedContentBytes.slice(0, encryptedContentBytes.length - tagLength);
        const tag = encryptedContentBytes.slice(encryptedContentBytes.length - tagLength);

        // 5. Construct JWE
        const encryptedKeyB64 = base64UrlEncode(new Uint8Array(encryptedKey));
        const ivB64 = base64UrlEncode(iv);
        const ciphertextB64 = base64UrlEncode(ciphertext);
        const tagB64 = base64UrlEncode(tag);

        return `${headerB64}.${encryptedKeyB64}.${ivB64}.${ciphertextB64}.${tagB64}`;

    } catch (e) {
        console.error("Encryption failed", e);
        throw e;
    }
};



globalThis.validateToken = async (jwk, token) => {
    try {
        const importJwk = {
            kty: jwk.kty,
            e: jwk.e,
            n: jwk.n,
            alg: "RS256",
            ext: true,
            key_ops: ["verify"]
        };

        const importedKey = await globalThis.crypto.subtle.importKey(
            "jwk",
            importJwk,
            {
                name: "RSASSA-PKCS1-v1_5",
                hash: "SHA-256"
            },
            false,
            ["verify"]
        );

        const parts = token.split(".");
        if (parts.length !== 3) {
            return false;
        }

        const header = parts[0];
        const payload = parts[1];
        const signature = parts[2];

        // Base64URL to Uint8Array
        const signatureStr = window.atob(signature.replaceAll("-", "+").replaceAll("_", "/"));
        const signatureBytes = new Uint8Array(signatureStr.length);
        for (let i = 0; i < signatureStr.length; i++) {
        signatureBytes[i] = signatureStr.codePointAt(i);
        }

        const dataBytes = new TextEncoder().encode(header + "." + payload);

        const isValid = await globalThis.crypto.subtle.verify(
            "RSASSA-PKCS1-v1_5",
            importedKey,
            signatureBytes,
            dataBytes
        );

        if (!isValid) {
            return false;
        }

        // Validate Lifetime (exp & nbf) to match C# ValidateLifetime = true
        try {
            let payloadStr = payload.replaceAll("-", "+").replaceAll("_", "/");
            // Add padding if missing
            while (payloadStr.length % 4 !== 0) {
                payloadStr += "=";
            }
            
            const decodedPayload = globalThis.atob(payloadStr);
            const payloadJson = JSON.parse(decodedPayload);
            const now = Math.floor(Date.now() / 1000);

            if (payloadJson.exp && now >= payloadJson.exp) {
                console.error("Token expired");
                return false;
            }

            if (payloadJson.nbf && now < payloadJson.nbf) {
                console.error("Token not yet valid (nbf)");
                return false;
            }
        } catch (e) {
            console.error("Token payload validation failed", e);
            return false;
        }

        return true;

    } catch (e) {
        console.error("Token validation failed", e);
        return false;
    }
};



// WEBPACK FOOTER //
// ./project/client/src/core/index.js